/**
 * 最近交易记录模块
 */
import { Module } from 'vuex'
import { EnumsState, RemoteEnumsKey } from './types'
import { FetchStatus, RootState } from '../types'
import { getPaymentChannelTypeEnum } from '@/api/mods/payment'

type Payload<T> = {
  key: RemoteEnumsKey,
  value: T,
}

enum mutationTypes {
  UPDATE_ENUMS = 'UPDATE_ENUMS',
  UPDATE_FETCH_STATUS = 'UPDATE_FETCH_STATUS',
}

// 枚举的请求列表
const requests = {
  [RemoteEnumsKey.PAYMENT_CHANNEL]: getPaymentChannelTypeEnum.request,
}

const initialState: EnumsState = {
  fetchStatus: {
    [RemoteEnumsKey.PAYMENT_CHANNEL]: FetchStatus.NONE,
  },
  // 不会缓存列表数据，所以此处不使用 paymentCode 作为索引
  enums: {
    [RemoteEnumsKey.PAYMENT_CHANNEL]: null,
  },
}

export const enums: Module<EnumsState, RootState> = {
  namespaced: true,
  state: initialState,
  actions: {
    /**
     * 获取指定枚举
     */
    async fetchEnums({ state, commit }, key: RemoteEnumsKey): Promise<void> {
      const currentFetchStatus = state.fetchStatus[key]

      // loaded 直接 return，其他任何状态都重新获取
      if (currentFetchStatus === FetchStatus.LOADED
      ) {
        return
      }

      try {
        commit(mutationTypes.UPDATE_FETCH_STATUS, {
          key,
          value: FetchStatus.LOADING,
        })

        const result = await requests[key]({}) as defs.EnumDto

        commit(mutationTypes.UPDATE_ENUMS, {
          key,
          value: result,
        })
        commit(mutationTypes.UPDATE_FETCH_STATUS, {
          key,
          value: FetchStatus.LOADED,
        })
      } catch (error) {
        commit(mutationTypes.UPDATE_FETCH_STATUS, {
          key,
          value: FetchStatus.FAILED,
        })

        throw error
      }
    },
  },
  mutations: {
    [mutationTypes.UPDATE_ENUMS](state, payload: Payload<defs.EnumDto[]>): void {
      state.enums[payload.key] = payload.value
    },
    [mutationTypes.UPDATE_FETCH_STATUS](state, payload: Payload<FetchStatus>): void {
      state.fetchStatus[payload.key] = payload.value
    },
  },
}
